import { compose } from '@grandvisionhq/utils'
import { Page, Props } from '@grandvisionhq/www-next/pages/search'

import { withCms, withLayout } from '../cms'

export default compose<Props, Props>(withCms(), withLayout())(Page)
